import ErrorPage from '@/components/ErrorPage'

export const createRoute = (path, element, errorElement = <ErrorPage />) => ({
  path,
  element,
  errorElement
})
